import { debug } from '@/shared/lib';

import { TRANSCRIPTOR_PREFERENCES_KEY } from '../config/constants';
import { TranscriptorPreferences } from '../config/types';

export const savePreferencesToStorage = (
  preferences: TranscriptorPreferences,
) => {
  try {
    localStorage.setItem(
      TRANSCRIPTOR_PREFERENCES_KEY,
      JSON.stringify(preferences),
    );
  } catch (error) {
    debug(error);
  }
};
